import { SolicitacaoService } from 'src/app/core/apis/orchestrador/api/solicitacao.service';
import { DatePipe, NgIf, UpperCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { IamService } from 'src/app/core/apis/iam/api/api';
import { OficiosService } from 'src/app/core/apis/orchestrador/api/oficios.service';
import { Globals } from 'src/app/core/helpers/globals';
import { CartaOrdemBaixaService } from 'src/app/core/service/cartas/carta-ordem-baixa.service';
import { CartaOrdemEnderecoService } from 'src/app/core/service/cartas/carta-ordem-endereco.service';
import { CartaPadraoService } from 'src/app/core/service/cartas/carta-padrao.service';
import { CartaRecifeService } from 'src/app/core/service/cartas/carta-recife.service';
import { Carta } from 'src/app/core/apis/orchestrador/model/carta';
import { ConsultarEnderecoComponent } from 'src/app/modules/ordem/cadastrar-ordem/consultar-endereco/consultar-endereco.component';
import { CartaService } from "../../../core/apis/orchestrador/api/carta.service";
import { OrdemService } from "../../../core/apis/orchestrador/api/ordem.service";
import { Ordem } from "../../../core/apis/orchestrador/model/ordem";
import { HttpResponse } from '@angular/common/http';
import { GenerateUrlCartaResponse } from '../../../core/apis/orchestrador/model/generateUrlCartaResponse';

@Component({
    selector: 'app-listar-ordem',
    templateUrl: './listar-ordem.component.html',
    styleUrls: ['./listar-ordem.component.css'],
    providers: [ConsultarEnderecoComponent, provideNgxMask()],
    standalone: true,
    imports: [
        MatToolbarModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMaskDirective,
        MatButtonModule,
        MatIconModule,
        NgIf,
        MatTableModule,
        MatPaginatorModule,
        UpperCasePipe,
        DatePipe,
        NgxMaskPipe,
    ],
})
export class ListarOrdemComponent implements OnInit {

  usuario;
  ordemBusinessError: boolean = false;
  spinner: boolean = false;
  pageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];


  displayedColumns: string[] = ['nroProcesso', 'tpOrdem','nroOrdem', 'nomeServidor', 'dtaAnotacao', 'status', 'cartaResposta', 'detalhes'];
  dataSource = new MatTableDataSource<Ordem>([]);

  @ViewChild(MatPaginator) paginatior: MatPaginator;

  form: FormGroup;
  nroProcessoParam;
  tokenIam;

  ConsultarEndereco: ConsultarEnderecoComponent

  constructor(
    private cartaPadrao: CartaPadraoService,
    private cartaOrdemBaixa: CartaOrdemBaixaService,
    private cartaOrdemEndereco: CartaOrdemEnderecoService,
    private cartaRecife: CartaRecifeService,
    private oficiosService: OficiosService,
    private solicitacaoService: SolicitacaoService,
    private iamService: IamService,
    private ordemService: OrdemService,
    private cartaService: CartaService,
    private globals: Globals,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroProcesso: ['', [
        Validators.minLength(20),
        Validators.maxLength(20)
      ]]
    });
  }

  ngOnInit() {
    this.tokenIam = sessionStorage.getItem("JWTToken");
    this.usuario = JSON.parse(sessionStorage.getItem('usuario'));
    this.nroProcessoParam = this.activatedRoute.snapshot.params['nroProcesso'];

    if (this.nroProcessoParam) {
      this.nroProcesso.setValue(this.nroProcessoParam);
    }

    this.globals.addToLoading('listar-ordem');
    this.iamService.changeAccount(this.tokenIam)
    .subscribe({
      next: response => {
        this.tokenIam  = response.body.accessToken;
        sessionStorage.setItem("JWTToken",this.tokenIam );
        this.getOrdemList();
      },
      error: error => {
        console.error(error)
      }
    });
  }

  public buscarPorNroProcesso() {
    this.globals.addToLoading('listar-ordem');
    this.getOrdemList();
  }

  public limparBusca() {
    this.nroProcesso.setValue("");
    this.buscarPorNroProcesso()
  }

  public getOrdemList() {
    this.spinner = true;
    this.ordemService.consultarOrdens(50, 0, this.nroProcesso.value, this.tokenIam)
    .subscribe({
      next: data => {
        this.dataSource.data = data.body.ordens;
        this.dataSource.paginator = this.paginatior;
        this.globals.subtractFromLoading();
      },
      error: error => {
        this.globals.subtractFromLoading();

        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case (error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
            break;

          case (error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
            break;

          case (error.status == 404):
            this.globals.showSnackBar(finalMessage || "Não foram encontradas ordens para os parametros informados.");
            break;

          case (error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
            break;

          case (error.status == 429):
            this.globals.showSnackBar(finalMessage || "Consulta de ordens: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
            break;

          default:
            this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao listar ordens, por favor, tente novamente mais tarde.");
            break;
        }
      }
    });
  }

  public detalharOrdem(ordem: Ordem) {
    this.router.navigate(['detalhar-ordem', ordem.nroProcesso], {
      state: { data: ordem, token: this.tokenIam }
    });
  }

  public getCartasIsFinalizado(idOrdem: number) {
    this.globals.addToLoading('listar-ordem');
    this.cartaService.consultarCarta(idOrdem, this.tokenIam).subscribe({
        next: data => {
          this.gerarCarta(data.body);
          this.globals.subtractFromLoading();
        },
        error: error => {
          this.globals.subtractFromLoading();

          let finalMessage = error?.error?.Erros?.[0]?.message;

          switch(true) {
            case (error.status == 400):
              this.globals.showSnackBar(finalMessage || "Requisição inválida, por favor verifique os dados e tente novamente.");
              break;

            case (error.status == 403):
              this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
              break;

            case (error.status == 404):
              this.globals.showSnackBar(finalMessage || "Carta não encontrada.");
              break;

            case (error.status == 422):
              this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
              break;

            case (error.status == 429):
              this.globals.showSnackBar(finalMessage || "Consulta de carta: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
              break;

            default:
              this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Consulta de carta indisponível, por favor tente novamente mais tarde.");
              break;
          }
        }
      });
  }

  // TODO - rever quando descontinuar implementacao
  private gerarCarta(carta: Carta) {
    if (carta.ordem.tpOrdem == 'ACAO' && carta.ordem.vara.foro.praca.nome == 'Recife')
      this.cartaRecife.gerarCarta(carta);
    else if (carta.ordem.tpOrdem == 'ACAO' && carta.ordem.baixa != null)
      this.cartaOrdemBaixa.gerarCarta(carta);
    else if (carta.ordem.tpOrdem == 'CEND')
      this.cartaOrdemEndereco.gerarCarta(carta);
    else
      this.cartaPadrao.gerarCarta(carta);
  }

  public getArquivoOficioResposta(ordem: Ordem){
    this.globals.addToLoading('listar-ordem');
    this.oficiosService.getDownloadArquivo(ordem.arquivoOficioResposta, this.tokenIam).subscribe({
      next: result => {
        const url = window.URL.createObjectURL(result.blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = result.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.globals.subtractFromLoading();
      },
      error: error => {
        console.error(error);

        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case (error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, por favor verifique os dados e tente novamente.");
            break;

          case (error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
            break;

          case (error.status == 404):
            this.globals.showSnackBar(finalMessage || "Carta não encontrada.");
            break;

          case (error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
            break;

          case (error.status == 429):
            this.globals.showSnackBar(finalMessage || "Download de carta: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
            break;

          default:
            this.globals.showSnackBar(finalMessage || "Erro ao baixar arquivo, por favor tente novamente mais tarde.");
            break;
        }

        this.globals.subtractFromLoading();
      }
    });
  }

  public getCartaSolicitacao(ordem: Ordem) {
    this.globals.addToLoading('listar-ordem');
    this.solicitacaoService.getArquivoUrl(ordem.arquivoOficioResposta, this.tokenIam).subscribe({
      next: (result: HttpResponse<GenerateUrlCartaResponse>) => {
        this.globals.subtractFromLoading();
        window.open(result.body.fileUrl,"_blank");
      },
      error: error => {
        console.error(error);
        this.globals.subtractFromLoading();
      }
    });
  }

  public setStyleByStatus(status: string): string {
    switch (status) {
      case 'Cancelado':
        return 'color: red';
      case 'Finalizado':
        return 'color: green';
      default:
        return 'color: blue';
    }
  }

  get nroProcesso() {
    return this.form.get('nroProcesso');
  }

}
